export class ServerSideEventError extends Error {
    constructor(
        readonly phase: 'parse' | 'subscriber' | 'connection',
        readonly cause: unknown
    ) {
        const message = `Failed to process SSE ${phase}`;
        super(message);
        this.name = 'ServerSideEventError';
    }
}
